import type { RootState } from 'store'

export const getInitialName = (state: RootState) =>
  state.reward?.values?.initialName ?? ''
export const getNameChecking = (state: RootState) =>
  state.reward?.values?.nameChecking ?? ''

export const getRewardType = (state: RootState) =>
  state.reward?.values?.rewardType
export const getFullName = (state: RootState) =>
  state.reward?.values?.fullName ?? ''
export const getShortName = (state: RootState) =>
  state.reward?.values?.shortName ?? ''
export const getMinScore = (state: RootState) =>
  state.reward?.values?.minScore ?? ''
export const getMaxScore = (state: RootState) =>
  state.reward?.values?.maxScore ?? ''
export const getMinYear = (state: RootState) =>
  state.reward?.values?.minYear ?? ''
export const getMaxYear = (state: RootState) =>
  state.reward?.values?.maxYear ?? ''
export const getScoreLevel = (state: RootState) =>
  state.reward?.values?.scoreLevel ?? null

export const getRewardTypeError = (state: RootState) =>
  state.reward?.errors?.rewardType ?? ''
export const getFullNameError = (state: RootState) =>
  state.reward?.errors?.fullName ?? ''
export const getShortNameError = (state: RootState) =>
  state.reward?.errors?.shortName ?? ''
export const getMinYearError = (state: RootState) =>
  state.reward?.errors?.minYear ?? ''
export const getMaxYearError = (state: RootState) =>
  state.reward?.errors?.maxYear ?? ''
export const getScoreLevelError = (state: RootState) =>
  state.reward?.errors?.scoreLevel ?? ''
